/**
 * Tab configuration for Agent Drawer
 *
 * @see asset/constants/drawerTabs.ts for reference pattern
 */

import {
  AgentDrawerTabId,
  AgentTabConfig,
} from '@/sections/agents/components/drawer/types';

/**
 * Tab ID constants for Agent Drawer
 *
 * Use these instead of string literals for type safety.
 */
export const AGENT_DRAWER_TABS = {
  OVERVIEW: 'overview',
  HEALTH: 'health',
  CREDENTIALS: 'credentials',
  TASKS: 'tasks',
  TUNNEL: 'tunnel',
  USERS: 'users',
  JOBS: 'jobs',
} as const satisfies Record<string, AgentDrawerTabId>;

/**
 * Tab labels for Agent Drawer tabs
 */
export const AGENT_DRAWER_TAB_LABELS: Record<AgentDrawerTabId, string> = {
  [AGENT_DRAWER_TABS.OVERVIEW]: 'Overview',
  [AGENT_DRAWER_TABS.HEALTH]: 'Health',
  [AGENT_DRAWER_TABS.CREDENTIALS]: 'Credentials',
  [AGENT_DRAWER_TABS.TASKS]: 'Tasks',
  [AGENT_DRAWER_TABS.TUNNEL]: 'Tunnel',
  [AGENT_DRAWER_TABS.USERS]: 'Users',
  [AGENT_DRAWER_TABS.JOBS]: 'Jobs',
};

/**
 * Complete tab configuration for Agent Drawer.
 *
 * Includes access control flags for Praetorian-only tabs.
 * Badge count is computed dynamically in useAgentTabs hook.
 *
 * Order determines tab display order in the UI.
 */
export const AGENT_DRAWER_TABS_CONFIG: AgentTabConfig[] = [
  {
    value: AGENT_DRAWER_TABS.OVERVIEW,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.OVERVIEW],
    praetorianOnly: false,
  },
  {
    value: AGENT_DRAWER_TABS.HEALTH,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.HEALTH],
    praetorianOnly: false,
  },
  {
    value: AGENT_DRAWER_TABS.CREDENTIALS,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.CREDENTIALS],
    praetorianOnly: false,
  },
  {
    value: AGENT_DRAWER_TABS.TASKS,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.TASKS],
    praetorianOnly: true,
  },
  {
    value: AGENT_DRAWER_TABS.TUNNEL,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.TUNNEL],
    praetorianOnly: true,
  },
  {
    value: AGENT_DRAWER_TABS.USERS,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.USERS],
    praetorianOnly: true,
  },
  {
    value: AGENT_DRAWER_TABS.JOBS,
    label: AGENT_DRAWER_TAB_LABELS[AGENT_DRAWER_TABS.JOBS],
    praetorianOnly: true,
  },
];

/**
 * Default tab ID when drawer opens
 */
export const AGENT_DRAWER_DEFAULT_TAB: AgentDrawerTabId =
  AGENT_DRAWER_TABS.OVERVIEW;
